/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const BarcodeIconConfig = {
  name: 'BarcodeIcon',
  height: 512,
  width: 512,
  svgPath: 'M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(BarcodeIconConfig);